
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Clock, CalendarDays, ClipboardList, Settings, Users } from "lucide-react";

const NavBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    {
      name: "Log",
      path: "/log",
      icon: ClipboardList,
    },
    {
      name: "Fasting",
      path: "/fasting",
      icon: Clock,
    },
    {
      name: "Calendar",
      path: "/calendar",
      icon: CalendarDays,
    },
    {
      name: "Friends",
      path: "/friends",
      icon: Users,
    },
    {
      name: "Settings",
      path: "/settings",
      icon: Settings,
    }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-lg rounded-t-xl border-t border-gray-100 z-50">
      <div className="flex justify-around items-center h-16 max-w-md mx-auto">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "flex flex-col items-center justify-center w-1/5 h-full transition-colors",
              currentPath === item.path
                ? "text-wellness-primary"
                : "text-gray-500 hover:text-wellness-secondary"
            )}
          >
            <item.icon className="h-5 w-5 mb-1" />
            <span className="text-xs font-medium">{item.name}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default NavBar;
